import React from 'react'

function FileUpload({ onFileChange, accept, children, ...rest }) {
    const fileInputRef = React.useRef(null)

    const handleFileChange = event => {
        onFileChange(event.target.files[0])
    }

    const openFilePicker = () => {
        fileInputRef.current.click()
    }

    // Attach the openFilePicker function to child components' onClick event
    const childrenWithProps = React.Children.map(children, child => {
        return React.cloneElement(child, {
            onClick: openFilePicker,
        })
    })

    return (
        <div>
            <input
                {...rest}
                type='file'
                ref={fileInputRef}
                accept={accept}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            {childrenWithProps}
        </div>
    )
}

export default FileUpload
